module.exports = __webpack_public_path__ + "static/media/back.2555408f.png";